import * as api from 'api';
import { backToEvent } from 'helper';
import { isThereError, lang_json, param, toggleLoader } from "signals/base";
import { msg, toggleModal, toggleToast } from 'signals/modal';

const get_translate = (lang) =>{
    api.translate({ jsonName: lang }).then((response) => {
        lang_json.value = response;
    }).catch((err) => {
        /** Handle error , show modal or toast error */
    }).then(()=>{
        toggleLoader(false)    
    })
}

const localize = (key) => {
    if (lang_json.value[key]) {
        return lang_json.value[key];
    } else {
        return key;
    }
};

const catch_error = (err_msg, isUsingModal = false) => {
    msg.value = err_msg;
    isThereError.value = true;
    if (isUsingModal || err_msg === 'not_logged_in') {
        // PLEASE HANDLE MODAL ERROR IF USER HAVENT PARAM OR NOT LOGGED IN
        toggleModal({ name: 'message', state: true })
    }
    else {
        toggleToast({ msg: err_msg, state: true, type: 'error' })
    }

    if (err_msg === "invalid_region") {
        window.localStorage.clear();
    }
};

const back_event = () =>{
	const { eventUrl, jwtToken, accessToken } = param.value;
    let URL = eventUrl;
    if(accessToken){
        let checkParam = URL?.indexOf("?") > -1;
        URL = `${URL}?access_token=${accessToken || jwtToken}`
        if (checkParam) {
            URL = `${URL}&access_token=${accessToken || jwtToken}`
        }
    }
    backToEvent(URL)
}

export {
    get_translate,
    localize,
    catch_error,
    back_event
}